import Vue from 'vue';
import axios from 'axios';
import Toasted from 'vue-toasted';
import VModal from 'vue-js-modal';
import VueTheMask from 'vue-the-mask';
import VTooltip from 'v-tooltip';

import Application from './Application.vue';
import store from './store';
import router from './router';

import Pretty from './filters/pretty';
import Highlight from './filters/highlight';

import Checkbox from './components/Checkbox.vue';
import Datetime from './components/Datetime';
import Spinner from './components/Spinner.vue';
import Upload from './components/Upload.vue';
import Account from './components/Account.vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Configuration from './components/Configuration.vue';
import Profile from './components/Profile.vue';
import TOC from './components/TOC.vue';
import Simulation from './components/Simulation.vue';
import Components from './components/Components.vue';
import ProductMetadata from './components/ProductMetadata.vue';
import ResourceSummary from './components/ResourceSummary.vue';
import Attachment from './components/Attachment.vue';
import Tag from './components/Tag.vue';

import Media from './components/chapter/Media.vue';
import MultipleChoice from './components/chapter/MultipleChoice.vue';
import MultipleChoiceOption from './components/chapter/MultipleChoiceOption.vue';
import SimulationInteraction from './components/chapter/SimulationInteraction.vue';
import List from './components/chapter/List.vue';
import Footnote from './components/chapter/Footnote.vue';
import Example from './components/chapter/Example.vue';
import Problem from './components/chapter/Problem.vue';
import Exercise from './components/chapter/Exercise.vue';
import Formula from './components/chapter/Formula.vue';
import Note from './components/chapter/Note.vue';
import Anchor from './components/chapter/Anchor.vue';
import PDF from './components/chapter/PDF.vue';
import Page from './components/chapter/Page.vue';
import Cover from './components/chapter/Cover.vue';
import ResourceReference from './components/chapter/ResourceReference.vue';
import IDOM from './components/chapter/IDOM.vue';
import Sidebar from './components/chapter/Sidebar.vue';
import Website from './components/chapter/Website.vue';
import Lesson from './components/chapter/Lesson.vue';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import './disablePrint';  // Import the disablePrint.js script

Vue.config.productionTip = false;

Vue.http = Vue.prototype.$http = axios;
Vue.bus = Vue.prototype.$bus = new Vue();

Vue.http.defaults.baseURL = '/api';

Vue.http.interceptors.response.use(response => {
    if(!response.data.$data){
        console.warn(`Call to ${response.config.url} did not include $data.`);
    }

    return response.data;
}, error => {
    //TODO Handle this better
    if(!error.response.data.$error){
        console.warn(`Error from ${error.config.url} did not include $error.`);
    }

    return Promise.reject(error.response.data);
});

Vue.use(VModal, {dynamic: true, injectModalsContainer: true, dynamicDefaults: {height: 'auto'}});

Vue.use(Toasted, {
    position: 'top-center',
    duration: 5000,
    containerClass: 'toast-container',
    className: 'toast',
    theme: 'bubble'
});

Vue.use(VueTheMask);
Vue.use(VTooltip);

require('./assets/less/global.less');

Vue.component('checkbox', Checkbox);
Vue.component('datetime-picker', VueCtkDateTimePicker);
Vue.component('datetime', Datetime);
Vue.component('spinner', Spinner);
Vue.component('primary-navigation', Header);
Vue.component('primary-footer', Footer);
Vue.component('upload', Upload);
Vue.component('configuration', Configuration);
Vue.component('account', Account);
Vue.component('profile', Profile);
Vue.component('toc', TOC);
Vue.component('simulation', Simulation);
Vue.component('components', Components);
Vue.component('product-metadata', ProductMetadata);
Vue.component('tag', Tag);

Vue.component('media', Media);
Vue.component('list', List);
Vue.component('footnote', Footnote);
Vue.component('multiple-choice', MultipleChoice);
Vue.component('multiple-choice-option', MultipleChoiceOption);
Vue.component('simulation-interaction', SimulationInteraction);
Vue.component('example', Example);
Vue.component('problem', Problem);
Vue.component('exercise', Exercise);
Vue.component('formula', Formula);
Vue.component('note', Note);
Vue.component('anchor', Anchor);
Vue.component('pdf', PDF);
Vue.component('page', Page);
Vue.component('cover', Cover);
Vue.component('resource-reference', ResourceReference);
Vue.component('idom', IDOM);
Vue.component('sidebar', Sidebar);
Vue.component('website', Website);
Vue.component('lesson', Lesson);

Vue.component('resource', ResourceSummary);
Vue.component('attachment', Attachment);

Vue.filter('pretty', Pretty);
Vue.filter('highlight', Highlight);

Promise.all([
    store.dispatch('user/load'),
    store.dispatch('publisher/load'),
    store.dispatch('integration/load'),
    store.dispatch('courses/load')
])
.finally(() => new Vue({router, store, render: h => h(Application)}).$mount('#application'));
